<!-- Список пунктов бокового меню с учетом доступов. -->
<template>
  <nav class="app-nav">
    <div
      class="collapse-btn desktop-only main-hidden"
      v-if="collapsed"
      @click.stop="$emit('toggle-collapse')"
      title="Свернуть/Развернуть"
    >
      <svg
        :class="{ rotated: collapsed }"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 18L9 12L15 6"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <ul v-if="!permissionsLoaded" class="nav-list nav-skeleton">
      <li v-for="n in 6" :key="n" class="nav-item nav-item--skeleton">
        <div class="skeleton-icon"></div>
        <div v-if="!collapsed" class="skeleton-label"></div>
      </li>
    </ul>

    <ul v-else class="nav-list">
      <!-- Главная -->
      <HomeItem
        v-bind="itemProps('home')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Мониторинг -->
      <TelemetryItem
        v-bind="itemProps('telemetry')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Автопарк -->
      <FleetItem
        v-bind="itemProps('fleet')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Календарь -->
      <CalendarItem
        v-bind="itemProps('calendar')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Планирование -->
      <PlanningItem
        v-bind="itemProps('planning')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Статистика -->
      <AnalyticsItem
        v-bind="itemProps('analytics')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Заказы -->
      <OrdersItem
        v-bind="itemProps('orders')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Путевые листы -->
      <WaybillsItem
        v-bind="itemProps('waybills')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Чаты -->
      <ChatsItem
        v-bind="itemProps('chats')"
        :unread-count="unreadChatsCount"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Рейсы -->
      <TripsItem
        v-bind="itemProps('trips')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Расходы -->
      <ExpensesItem
        v-bind="itemProps('expenses')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Ремонт -->
      <RepairsItem
        v-bind="itemProps('repairs')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <WarehouseItem
        v-bind="itemProps('warehouse')"
      />

      <!-- Транспортные средства -->
      <VehiclesItem
        v-bind="itemProps('vehicles')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Водители -->
      <DriversItem
        v-bind="itemProps('drivers')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Контрагенты -->
      <CounterpartiesItem
        v-bind="itemProps('counterparties')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <CommunicationItem
        v-bind="itemProps('communication')"
      />

      <!-- ЭДО -->
      <EdoDocumentsItem
        v-bind="itemProps('edo_documents')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      />

      <!-- Общий доступ временно скрыт до отдельного запуска раздела. -->
      <!-- <SharingsItem
        v-bind="itemProps('sharings')"
        @navigate="forwardNavigate"
        @middle-click="forwardMiddleClick"
        @context-menu="forwardContextMenu"
      /> -->
    </ul>
  </nav>
</template>

<script>
import CommunicationItem from "@/components/AppSidebar/items/CommunicationItem.vue";
import WarehouseItem from "@/components/AppSidebar/items/WarehouseItem.vue";
import HomeItem from "@/components/AppSidebar/items/HomeItem.vue";
import TelemetryItem from "@/components/AppSidebar/items/TelemetryItem.vue";
import AnalyticsItem from "@/components/AppSidebar/items/AnalyticsItem.vue";
import PlanningItem from "@/components/AppSidebar/items/PlanningItem.vue";
import CounterpartiesItem from "@/components/AppSidebar/items/CounterpartiesItem.vue";
import OrdersItem from "@/components/AppSidebar/items/OrdersItem.vue";
// import SharingsItem from "@/components/AppSidebar/items/SharingsItem.vue";
import TripsItem from "@/components/AppSidebar/items/TripsItem.vue";
import WaybillsItem from "@/components/AppSidebar/items/WaybillsItem.vue";
import ChatsItem from "@/components/AppSidebar/items/ChatsItem.vue";
import DriversItem from "@/components/AppSidebar/items/DriversItem.vue";
import RepairsItem from "@/components/AppSidebar/items/RepairsItem.vue";
import FleetItem from "@/components/AppSidebar/items/FleetItem.vue";
import CalendarItem from "@/components/AppSidebar/items/CalendarItem.vue";
import VehiclesItem from "@/components/AppSidebar/items/VehiclesItem.vue";
import ExpensesItem from "@/components/AppSidebar/items/ExpensesItem.vue";
import EdoDocumentsItem from "@/components/AppSidebar/items/EdoDocumentsItem.vue";

export default {
  name: "AppSidebarItems",
  components: {
    CommunicationItem,
    WarehouseItem,
    HomeItem,
    TelemetryItem,
    AnalyticsItem,
    PlanningItem,
    CounterpartiesItem,
    OrdersItem,
    // SharingsItem,
    TripsItem,
    WaybillsItem,
    ChatsItem,
    DriversItem,
    RepairsItem,
    FleetItem,
    CalendarItem,
    VehiclesItem,
    ExpensesItem,
    EdoDocumentsItem,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
    activeItem: {
      type: String,
      required: true,
    },
    permissionsLoaded: {
      type: Boolean,
      default: false,
    },
    canSeePage: {
      type: Function,
      required: true,
    },
    unreadChatsCount: {
      type: Number,
      default: 0,
    },
    newBadgeEnabled: {
      type: Function,
      required: true,
    },
  },
  emits: [
    "toggle-collapse",
    "navigate",
    "middle-click",
    "context-menu",
  ],
  methods: {
    itemProps(itemKey) {
      return {
        collapsed: this.collapsed,
        activeItem: this.activeItem,
        canSeePage: this.canSeePage,
        showNewBadge: this.newBadgeEnabled(itemKey),
      };
    },

    forwardNavigate(event, routeName) {
      this.$emit("navigate", event, routeName);
    },

    forwardMiddleClick(event, routeName) {
      this.$emit("middle-click", event, routeName);
    },

    forwardContextMenu(event, routeName) {
      this.$emit("context-menu", event, routeName);
    },
  },
};
</script>
